import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { e as SKELETON_VARIANTS } from "./index-1iHOddfZ.js";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const MockGatsbyLink = forwardRef(({ to, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockGatsbyLink", ref, href: to, ...props }));
const MockNextLink = forwardRef(({ href, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockNextLink", ref, href, ...props }));
const mockSkeletonNavBar = [
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 99,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 82,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 122,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 93,
    height: 37
  }
];
const mockSkeletonMarketplace = [
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  }
];
const mockSkeletonSearchCTA = [
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 132,
    height: 48,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 138,
    height: 48
  }
];
const Headline = styled("h2")(({ theme }) => ({
  margin: 0,
  fontSize: "42px",
  fontWeight: 300,
  fontHeight: "115%"
}));
const SubHeadline = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: "18px",
  fontWeight: 400,
  fontHeight: "160%"
}));
const MockCustomOfferCardChildren = () => /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: "16px", color: "#333" }, children: [
  /* @__PURE__ */ jsx(Headline, { children: "Let us help you choose." }),
  /* @__PURE__ */ jsx(SubHeadline, { children: "Quicken Loans can help pair you with lenders based on your specific needs." })
] });
export {
  MockCustomOfferCardChildren as M,
  MockGatsbyLink as a,
  MockNextLink as b,
  mockSkeletonNavBar as c,
  mockSkeletonSearchCTA as d,
  mockSkeletonMarketplace as m
};
//# sourceMappingURL=MockCustomOfferCardChildren-DxvnBOmc.js.map
